var t=new class{constructor(){this.type="none"}toJSONObject(){return{type:this.type}}};export{t as NoViewfinder};